// auth.api.ts
import api, { client } from '@/shared/api/api';
import { AuthResponse, LoginPayload } from '../model';

export interface ForgotPasswordPayload {
  email: string;
  redirectTo: string;
}

export interface ResetPasswordPayload {
  newPassword: string;
  token: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export const authApi = {
  login: async (payload: LoginPayload): Promise<AuthResponse> => {
    const res = await api<AuthResponse>({
      url: '/v1/auth/login-web',
      method: 'POST',
      data: payload,
    });
    return res;
  },

  logout: async (): Promise<void> => {
    await api({
      url: '/v1/auth/logout-web',
      method: 'POST',
    });
  },

  /**
   * Logout silencioso usado quando a sessão já expirou (auth:refresh-failed).
   * Usa skipAuthRefresh para evitar disparar outro fluxo de refresh que causaria race condition.
   */
  logoutSilent: async (): Promise<void> => {
    try {
      await client({
        url: '/v1/auth/logout-web',
        method: 'POST',
        withCredentials: true,
        skipAuthRefresh: true,
      });
    } catch {
      // Ignora erros - sessão já está inválida, o importante é limpar o estado local
    }
  },

  forgotPassword: async (payload: ForgotPasswordPayload): Promise<ForgotPasswordResponse> => {
    return api<ForgotPasswordResponse>({
      url: '/v1/auth/forgot-password',
      method: 'POST',
      data: payload,
    });
  },

  resetPassword: async (payload: ResetPasswordPayload): Promise<ResetPasswordResponse> => {
    return api<ResetPasswordResponse>({
      url: '/v1/auth/change-password',
      method: 'POST',
      data: payload,
    });
  },
};
